import { createSelector } from "reselect";
import { initialState } from "../reducers/dashboard.reducer";
import { DASHBOARD } from "../constants/dashboard.constants";
import { selectCurrentUser } from "./app.selectors";

const selectState = (state) => state[DASHBOARD] || initialState;

// V4 saves a dashboard into the account itself, which takes update rights on it.
export const selectCanEditDashboards = () =>
  createSelector(
    selectCurrentUser(),
    (user) =>
      !!user?.isAdmin &&
      (!user.isV4Native || user.canUpdateV4Account(user.v4ScopedAccountId))
  );

export const selectDashboards = () =>
  createSelector(selectState, (state) => state.get("data").valueSeq().toList());
export const selectDashboardsFetched = () =>
  createSelector(selectState, (state) => state.get("fetched"));
export const selectSelectedDashboard = () =>
  createSelector(selectState, (state) => state.get("selected"));
export const selectEditDashboard = () =>
  createSelector(selectState, (state) => state.get("editDashboard"));
export const selectLoading = () =>
  createSelector(selectState, (state) => state.get("loading"));
export const selectLegacyTiles = () =>
  createSelector(selectState, (state) => state.get("legacyTiles"));
